import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { PlantListInitialState, PlantListLoad } from './plant-list.actions';
import { PlantListState, PlantListStateModel } from './plant-list.state';
import { PlantListSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class PlantListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<PlantListStateModel> = this.store.select(PlantListState.getState);
  loaded$: Observable<boolean> = this.store.select(PlantListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Plants)
      .subscribe((searchCriteria: PlantListSearchCriteria) => {
        this.store.dispatch(new PlantListLoad(searchCriteria));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new PlantListInitialState());
  }
}
